<template>
  <div>

    <el-table
        :data="fundData"
        size='small'
        :default-sort="{ prop: 'canTradeRateYear', order: 'descending' }"
        :row-class-name="rowClassNameByYieldYear"
        @row-click="handleRowClick"
    >
      <el-table-column label="基金" width="65" >
        <template #default="scope">
        <span style="font-size: 10px;">
          {{ scope.row.fundCode }}<br>{{ scope.row.fundName }}
        </span>
        </template>
      </el-table-column>
      <!--      <el-table-column-->
      <!--          prop="fundName"-->
      <!--          label="基金名称"-->
      <!--          width="70"-->
      <!--      ></el-table-column>-->
      <el-table-column
          prop="gz"
          label="估值/当前价格"
          width="55"
      >
        <template #default="scope">
        <span style="font-size: 11px;">
          {{ scope.row.gz }}<br>{{ scope.row.price }}
        </span>
        </template>
      </el-table-column>
      <el-table-column
          label="折溢价"
          width="70"
          sortable
          :sort-method="sortDiscount"
      >
        <template #default="scope">
        <span :style="getCellStyle(scope.row.discount)">
          {{ scope.row.discount }}%
        </span>
        </template>
      </el-table-column>
      <el-table-column
          label="可成交费后收益率"
          width="70"
          sortable
          :sort-method="sortCanTradeRate"
      >
        <template #default="scope">
        <span>
          {{ scope.row.canTradeRate }}%
        </span>
        </template>
      </el-table-column>
      <el-table-column
          label="可成交费后年华" width="65"
          sortable
          prop="canTradeRateYear"
          :sort-method="sortCanTradeRateYear">
        <template #default="scope">
        <span>
          {{ parseInt(scope.row.canTradeRateYear) }}%
        </span>
        </template>
      </el-table-column>

      <el-table-column
          prop="amount"
          label="当天成交额"
          width="58"
          :filters="[
        { text: '当日>十万', value: 100000 },
        { text: '当日>一万', value: 10000 },]"
          :filter-method="filterAmount"
          filter-placement="bottom"
      >
        <template #default="scope">
        <span>
          {{ formatAmountToWan(scope.row.amount) }}
        </span>
        </template>

      </el-table-column>
      <el-table-column
          label="申购限额"
          width="65"
          :filters="[
        { text: '<10000', value: 10000 },
        { text: '<1000', value: 1000 },]"
          :filter-method="filterSg"
          filter-placement="bottom"
      >
        <template #default="scope">
        <span>
          {{ formatToWan(scope.row.maxSg) }}
        </span>
        </template>
      </el-table-column>
      <el-table-column
          prop="rdmcfmdataday"
          label="申购到账日期"
          width="100"
      ></el-table-column>
      <el-table-column
          prop="drawcfmdataday"
          label="赎回到账日期"
          width="100"
      ></el-table-column>
      <el-table-column
          prop="redemptionRateOver7"
          label="赎回费"
          width="60"
      ></el-table-column>
    </el-table>
    <pol-dialog
        v-model:visible="dialogVisible"
        :fundCode="clickItem.fundCode"
        :fundName="clickItem.fundName"
        :yesterdayVolume="clickItem.yesterdayVolume"
        :valuation="clickItem.valuation"
        :redemptionFeeRate="clickItem.redemptionFeeRate"
        :redemptionDate="clickItem.redemptionDate"
        :subscriptionFeeRate="clickItem.subscriptionFeeRate"
        :subscriptionDate="clickItem.subscriptionDate"
        :maxSubscriptionAmount="clickItem.maxSubscriptionAmount"
    />
  </div>
</template>

<script setup>
import {ref, onMounted, inject} from 'vue';
import axios from 'axios';
import { defineProps } from 'vue';
import PolDialog from "@/components/dialog/PolDialog.vue"; // 显式导入 defineProps

// 定义 props
const props = defineProps({
  fundDataUrl: {
    type: String,
    required: true
  }
});
// 注入 sharedData
const sharedData = inject('sharedData');

// 定义响应式数据
const fundData = ref([]);
const gzUpdateTime = ref('');
const clickItem = ref(0);

/** 兼容接口直接返回数组，或 { updateTime, fundGzData } */
const parseFundResponse = (data) => {
  if (Array.isArray(data)) {
    return {
      updateTime: data[0]?.updateTime ?? new Date().toISOString(),
      rows: data,
    };
  }
  return {
    updateTime: data?.updateTime ?? new Date().toISOString(),
    rows: data?.fundGzData ?? [],
  };
};

/** 表格列 prop 与部分接口字段名不一致时做别名 */
const normalizeFundRow = (row) => {
  const r = { ...row };
  if (r.rdmcfmdataday == null && r.rdmcfmdataToday != null) r.rdmcfmdataday = r.rdmcfmdataToday;
  if (r.drawcfmdataday == null && r.drawcfmdataToday != null) r.drawcfmdataday = r.drawcfmdataToday;
  return r;
};

// 定义方法
const fetchFundData = () => {
  console.debug('fetchFundData fundDataUrl:', props.fundDataUrl);
  axios.get(props.fundDataUrl).then(response => {
    console.debug('fetchFundData response:', response);
    const { updateTime, rows } = parseFundResponse(response.data);
    gzUpdateTime.value = updateTime;
    sharedData.updateMessage(updateTime);
    fundData.value = Array.isArray(rows) ? rows.map(normalizeFundRow) : [];
  }).catch(error => {
    console.error('Error fetching fund data:', error);
  });
};

/** 可成交费后年化小于 10% 时整行置灰 */
const rowClassNameByYieldYear = ({ row }) => {
  const y = parseFloat(row.canTradeRateYear);
  if (!Number.isNaN(y) && y < 10) {
    return 'fund-row-low-year-rate';
  }
  return '';
};

// 排序方法
const sortDiscount = (a, b) => parseFloat(a.discount) - parseFloat(b.discount);
const sortCanTradeRate = (a, b) => parseFloat(a.canTradeRate) - parseFloat(b.canTradeRate);
const sortCanTradeRateYear = (a, b) => parseFloat(a.canTradeRateYear) - parseFloat(b.canTradeRateYear);

// 样式方法
const getCellStyle = (value) => {
  if (value > 0) {
    return {color: 'red'}; // 正值显示红色
  } else if (value < 0) {
    return {color: 'green'}; // 负值显示绿色
  }
  return {}; // 零值默认颜色
};

// 格式化方法
const formatToWan = (num) => {
  if (num >= 10000 && num <= 1000000) {
    return parseInt(num / 10000) + '万'; // 百万以内转换为 x 万
  } else if (num >= 1000000) {
    return '无限制';
  } else {
    return parseInt(num);
  }
};

const handleRowClick = (row, column, event) => {
  console.log('行被点击', row);
  console.log('被点击的列', column);
  console.log('原生事件', event);
  clickItem.value = {
    fundCode: row.fundCode,
    fundName: row.fundName,
    yesterdayVolume: row.yesterdayAmount,
    redemptionFeeRate: row.redemptionRateOver7,
    redemptionDate: row.drawcfmdataday,
    subscriptionFeeRate: 0,
    subscriptionDate: row.rdmcfmdataday,
    maxSubscriptionAmount: row.maxSg
  };
  console.log('clickItem.value ', clickItem.value );
  openDialog()
};

const formatAmountToWan = (num) => {
  if (num == null || num === '' || Number.isNaN(Number(num))) {
    return '-';
  }
  const n = Number(num);
  if (n >= 10000) {
    return parseInt(n / 10000) + '万';
  }
  return parseInt(n);
};

// // 计算属性
// const formattedTime = () => {
//   const date = new Date(gzUpdateTime.value);
//   return date.toLocaleString(); // 使用默认的本地化格式
// };

// 筛选方法
const filterSg = (value, row) => {
  return row.maxSg < value;
};

const filterAmount = (value, row) => {
  const a = Number(row.amount);
  return !Number.isNaN(a) && a > value;
};

// 定义响应式变量
const dialogVisible = ref(false);

// 打开对话框
const openDialog = () => {
  dialogVisible.value = true;
};

// 在组件挂载时调用 fetchFundData
onMounted(fetchFundData);
</script>

<style scoped>
:deep(.el-table .fund-row-low-year-rate > td.el-table__cell) {
  background-color: #e8e8e8 !important;
}
:deep(.el-table .fund-row-low-year-rate:hover > td.el-table__cell) {
  background-color: #dedede !important;
}
</style>
